export default __webpack_public_path__ + "static/media/codeInLogo.e41a71d5.webp";